export default __webpack_public_path__ + "b950fea.png";